<template>
  <article class="layout-section -bg-primary">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">{{ wp.pricing.title }}</h2>
      <p>{{ wp.pricing.subtitle }}</p>
    </div>

    <section class="pricing">
      <article v-for="group in wp.pricing.groups" :key="group.title" class="pricing__box">
        <div class="pricing__hgroup">
          <h3 class="pricing__title">{{ group.title }}</h3>
          <span v-if="group.description">
            {{ group.description }}
          </span>
        </div>

        <div v-for="entry in group.rows" :key="entry.label" class="pricing__row">
          <h4>{{ entry.label }}</h4>
          <h5>{{ entry.price }}</h5>
        </div>
      </article>
    </section>
  </article>
</template>

<script>
export default {
  name: 'RegisterPricing',
  inject: ['wp']
}
</script>
